<div class="d-flex flex-column gap-3">
    <app-page-divider [text]="'assignments.billedAssignments.detailsOverview' | transloco"
        [icon]="'fa-solid fa-circle-info'">
    </app-page-divider>

    <app-spinner *ngIf="periodDetail == null"></app-spinner>

    <ng-container *ngIf="periodDetail">
        <app-billed-assignments-period-details [period]="periodDetail!">
        </app-billed-assignments-period-details>
    </ng-container>

    <app-page-divider [text]="'assignments.billedAssignments.assignmentsList' | transloco"
        [icon]="'fa-solid fa-calendar-days'">
    </app-page-divider>

    <app-spinner *ngIf="periodDetail == null"></app-spinner>

    <ng-container *ngIf="periodDetail">
        <div class="d-flex flex-column gap-2 text-center">
            <ng-container *ngFor="let assignmentItem of periodDetail.items">
                <app-billed-assignment-item [item]="assignmentItem"></app-billed-assignment-item>
            </ng-container>
        </div>
    </ng-container>
</div>